import React from 'react';
import GoogleMapReact from 'google-map-react';
import styled from 'styled-components';

const MapContainer = styled.div`
  height: 30vh;
`;

const renderMarkers = ({ map, maps, lat, lng, address }) => {
  new maps.Marker({
    position: { lat, lng },
    map,
    title: <div>{address}</div>
  });
};

const Map = ({ secret, lat, lng, zoom, address }) => (
  <MapContainer>
    <GoogleMapReact
      center={{ lat, lng }}
      defaultZoom={zoom}
      bootstrapURLKeys={secret ? { key: secret } : ''}
      onGoogleApiLoaded={({ map, maps }) =>
        renderMarkers({ map, maps, lat, lng, address })
      }
    />
  </MapContainer>
);

export default Map;
